module.exports = __webpack_public_path__ + "a8e30a18ffec6c8e0acb5a257b26ef50.svg";